export const SITE_URL = "https://millionaireconnector.com";
export const BRAND = "Millionaire Connector";
export const TAGLINE = "We Turn Songs Into Trends";
export const POSITIONING = "India's No.1 Song Promotion Agency";
export const WHATSAPP_URL = "https://wa.me/916367103951";
export const INSTAGRAM_URL = "https://www.instagram.com/millionaireconnector_";
export const PHONE_DISPLAY = "+91 6367-103951";
export const PHONE_TEL = "tel:+916367103951";
export const EMAIL = "Millionaireconnecter@gmail.com";

export const waLink = (message) =>
  `${WHATSAPP_URL}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT = waLink(
  "Hi Millionaire Connector, I want to promote my song. Please share campaign details."
);
export const WA_SPOTIFY = waLink(
  "Hi Millionaire Connector, I want Spotify playlist campaign details for my track."
);
export const WA_SPOTIFY_SLOT = waLink(
  "Hi Millionaire Connector, I want to book a Spotify playlist promotion slot. Please share the available options and delivery details."
);
export const WA_BOOK_SLOT = waLink(
  "Hi Millionaire Connector, I want to book a Spotify playlist promotion slot. Please share the available options."
);
export const WA_SPOTIFY_CUSTOM = waLink(
  "Hi Millionaire Connector, I want a custom Spotify campaign quote. Please recommend the right campaign slot for my order size."
);
export const WA_REELS = waLink(
  "Hi Millionaire Connector, I want to plan an Instagram Reels campaign for my song."
);
export const WA_QUOTE = waLink(
  "Hi Millionaire Connector, I want a campaign quote for my music. Please share the available options."
);

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Spotify Promotion", to: "/spotify-playlist-promotion" },
  { label: "Instagram Reels", to: "/instagram-reels-promotion" },
  { label: "YouTube Promotion", to: "/youtube-music-promotion" },
  { label: "Creator Network", to: "/#creator-network" },
  { label: "Results", to: "/#results" },
  { label: "Why Us", to: "/#why-spotify" },
  { label: "Contact", to: "/contact" },
];

export const HERO_TRUST_POINTS = [
  "1,000+ Active Playlists",
  "800+ Clients",
  "3M+ Monthly Streams Across Client Campaigns",
];

export const STATS_BAND = [
  { value: 800, suffix: "+", label: "Clients Served" },
  { value: 3, suffix: "M+", label: "Monthly Streams Across Client Campaigns" },
  { value: 1000, suffix: "+", label: "Active Playlists" },
  { value: 1.7, suffix: "M+", label: "Top Reel Campaign Result", decimals: 1 },
];

export const SPOTIFY_PRICING = [
  { streams: "10K\u201312K", price: "\u20B95,000" },
  { streams: "20K\u201322K", price: "\u20B99,000" },
  { streams: "30K\u201333K", price: "\u20B912,000" },
  { streams: "50K\u201353K", price: "\u20B917,000" },
  { streams: "100K\u2013105K", price: "\u20B932,000", featured: true },
];

export const RESULT_PAIRS = [
  {
    id: "01",
    artist: "Aryan",
    metric: "Monthly Listeners",
    before: "11.3K",
    after: "35.1K",
    beforeImg: "/proof/spotify-result-01-before.jpeg",
    afterImg: "/proof/spotify-result-01-after.webp",
    beforeW: 588,
    beforeH: 1280,
    afterW: 920,
    afterH: 2000,
    beforeAlt:
      "Spotify artist profile of Aryan before the Millionaire Connector playlist campaign, showing 11.3K monthly listeners",
    afterAlt:
      "Spotify artist profile of Aryan after the Millionaire Connector playlist campaign, showing 35.1K monthly listeners",
  },
  {
    id: "02",
    artist: "Bikram Singh",
    metric: "Monthly Listeners",
    before: "90.8K",
    after: "1.2L",
    beforeImg: "/proof/spotify-result-02-before.jpeg",
    afterImg: "/proof/spotify-result-02-after.webp",
    beforeW: 588,
    beforeH: 1280,
    afterW: 920,
    afterH: 2000,
    beforeAlt:
      "Spotify artist profile of Bikram Singh before the Millionaire Connector playlist campaign, showing 90.8K monthly listeners",
    afterAlt:
      "Spotify artist profile of Bikram Singh after the Millionaire Connector playlist campaign, showing 1.2L monthly listeners",
  },
  {
    id: "03",
    artist: "DAINOWAY",
    metric: "Monthly Listeners",
    before: "38",
    after: "52K",
    beforeImg: "/proof/spotify-result-03-before.jpeg",
    afterImg: "/proof/spotify-result-03-after.webp",
    beforeW: 588,
    beforeH: 1280,
    afterW: 920,
    afterH: 2000,
    beforeAlt:
      "Spotify artist profile of DAINOWAY before the Millionaire Connector playlist campaign, showing 38 monthly listeners",
    afterAlt:
      "Spotify artist profile of DAINOWAY after the Millionaire Connector playlist campaign, showing 52K monthly listeners",
  },
  {
    id: "04",
    artist: "IQQANVE",
    metric: "Monthly Listeners",
    before: "169",
    after: "43.7K",
    beforeImg: "/proof/spotify-result-04-before.jpeg",
    afterImg: "/proof/spotify-result-04-after.webp",
    beforeW: 588,
    beforeH: 1280,
    afterW: 920,
    afterH: 2000,
    beforeAlt:
      "Spotify artist profile of IQQANVE before the Millionaire Connector playlist campaign, showing 169 monthly listeners",
    afterAlt:
      "Spotify artist profile of IQQANVE after the Millionaire Connector playlist campaign, showing 43.7K monthly listeners",
  },
];

export const RESULT_VIDEOS = [
  {
    id: "01",
    src: "/proof/spotify-results-video-01.mp4",
    poster: "/proof/spotify-results-video-01-poster.jpg",
    label: "Screen recording of a client Spotify for Artists dashboard during an active playlist campaign.",
  },
];

export const MAIN_SERVICES = [
  {
    icon: "ListMusic",
    title: "Spotify Playlist Promotion",
    tag: "Flagship Service",
    desc: "Genre-targeted playlist campaigns on a network of 1,000+ active playlists, structured around your order size and preferred delivery pace.",
    benefits: [
      "Genre & audience-matched playlist placement",
      "Delivery paced to your order size",
      "Clear campaign reporting",
    ],
    includes: "Curator pitching \u00B7 Campaign slots \u20B95,000\u2013\u20B932,000 \u00B7 Delivery updates",
    link: "/spotify-playlist-promotion",
  },
  {
    icon: "Instagram",
    title: "Instagram Reels Promotion",
    tag: "High Volume",
    desc: "Creator-led Reels campaigns that turn your track into a visual trend across regional Indian audiences.",
    benefits: [
      "250+ creators per major region",
      "7K\u201310K reels/day campaign capability",
      "Punjabi & Haryanvi lyrics pages",
    ],
    includes: "Creator briefing \u00B7 Bulk reels \u00B7 Campaign reporting",
    link: "/instagram-reels-promotion",
  },
  {
    icon: "Youtube",
    title: "YouTube Music Promotion",
    tag: "Video Reach",
    desc: "Audience-targeted YouTube campaigns for official music videos, lyrical videos and audio premieres.",
    benefits: [
      "Language & genre audience targeting",
      "Premiere and release-day pushes",
      "Performance updates",
    ],
    includes: "Campaign planning \u00B7 Audience targeting \u00B7 Reporting",
    link: "/youtube-music-promotion",
  },
  {
    icon: "Megaphone",
    title: "Music & Artist Promotion",
    tag: "Full Stack",
    desc: "Complete release campaigns combining Spotify playlists, Instagram Reels, YouTube and lyrics-page networks.",
    benefits: [
      "One coordinated release strategy",
      "Spotify + Reels + YouTube combined",
      "Built for artists, labels and brands",
    ],
    includes: "Release strategy \u00B7 Multi-channel execution \u00B7 Reporting",
    link: "/artist-promotion",
  },
];

export const SERVICES = [
  {
    icon: "ListMusic",
    title: "Spotify Playlist Promotion",
    text: "Our flagship service. Genre-targeted Spotify playlist promotion and playlist pitching built on a network of 1,000+ active playlists — campaigns structured around your order size and preferred delivery pace.",
    link: "/spotify-playlist-promotion",
    linkLabel: "Spotify Playlist Promotion",
  },
  {
    icon: "Instagram",
    title: "Instagram Reels Promotion",
    text: "Strategic Instagram Reels promotion through creator-led campaigns built for music discovery. As an Instagram Reels promotion agency, we run song reels promotion and music reels promotion designed around regional audiences.",
    link: "/instagram-reels-promotion",
    linkLabel: "Instagram Reels Promotion",
  },
  {
    icon: "Music2",
    title: "Song Promotion",
    text: "Targeted song promotion services for artists and labels releasing new music. From new song promotion to sustained catalog pushes, campaigns built around your audience, language and genre.",
    link: "/song-promotion",
    linkLabel: "Song Promotion Services",
  },
  {
    icon: "Layers",
    title: "Bulk Reels Campaigns",
    text: "High-volume Reel distribution built for rapid awareness and audio discovery. Our network deploys 7K\u201310K reels per day, turning one track into thousands of creator-led posts across regions.",
    link: "/instagram-reels-promotion-agency",
    linkLabel: "Bulk Reels Campaigns",
  },
  {
    icon: "Users",
    title: "Creator & Influencer Marketing",
    text: "Region-specific creator campaigns across Punjab, Haryana, Rajasthan, Hindi markets and pan-India audiences. Verified creators matched to your genre, language and release goals.",
    link: "/creator-marketing",
    linkLabel: "Creator Marketing",
  },
  {
    icon: "ScrollText",
    title: "Lyrics Page Promotion",
    text: "Dedicated Punjabi and Haryanvi lyrics-page networks that keep your song visible long after release week — sustained discovery through high-follower lyrics pages.",
    link: "/music-promotion",
    linkLabel: "Lyrics Page Promotion",
  },
  {
    icon: "Crown",
    title: "Premium Pages Promotion",
    text: "Access to high-reach social pages across music, entertainment and regional niches — premium placements that put your track in front of established audiences.",
    link: "/music-promotion-agency",
    linkLabel: "Premium Page Promotion",
  },
  {
    icon: "Megaphone",
    title: "Brand Promotion",
    text: "Use our creator and page network for campaigns beyond music — product launches, brand anthems and regional brand pushes powered by the same distribution engine.",
    link: "/music-influencer-marketing",
    linkLabel: "Brand Promotion",
  },
];

export const CREATOR_NETWORK = [
  { region: "Haryana", value: 250, suffix: "+", label: "verified creators" },
  { region: "Rajasthan", value: 250, suffix: "+", label: "influencers" },
  { region: "Punjab", value: 250, suffix: "+", label: "content creators" },
  { region: "Hindi", value: 250, suffix: "+", label: "pan-India specialists" },
  { region: "Punjab & Haryana Nano Creators", value: 300, suffix: "+", label: "micro-influencers" },
  { region: "Haryanvi Lyrics Pages", value: 100, suffix: "+", label: "pages" },
  { region: "Punjabi Lyrics Pages", value: 100, suffix: "+", label: "pages" },
];

export const CASE_STUDIES = [
  { song: "Iski Bahan Ke Mje Mje", reels: "1.7M+" },
  { song: "Guzara", reels: "580K+" },
  { song: "Andaj", reels: "272K+" },
  { song: "Pagal Ho Jaugi", reels: "240K+" },
  { song: "Hello Hanji", reels: "205K+" },
  { song: "Sawri Sawri", reels: "201K+" },
];

export const HOME_FAQS = [
  {
    q: "What is Spotify playlist promotion?",
    a: "Spotify playlist promotion places your track on genre-relevant playlists so it reaches listeners who already enjoy your style of music. Our campaigns run on a network of 1,000+ active playlists, matched by genre, language and audience, with delivery paced to your order size.",
  },
  {
    q: "How does Spotify playlist promotion work?",
    a: "You send us your track and choose a campaign slot. We match your song to suitable playlists from our network, the campaign goes live, and you receive updates as delivery progresses. Smaller campaigns are generally paced around 1.5K\u20132K streams/day; larger campaigns can scale to 10K+ streams/day depending on requirements.",
  },
  {
    q: "How long does a music promotion campaign take?",
    a: "Spotify campaigns build over days to weeks depending on order size and pacing. Reels campaigns typically go live within days and run one to four weeks. We share the expected timeline before your campaign starts.",
  },
  {
    q: "Do you work with independent artists?",
    a: "Yes — a large share of our 800+ clients are independent artists. Spotify campaign slots start at \u20B95,000 and Reels campaigns scale to budget, so independent releases get the same networks and reporting as label campaigns.",
  },
  {
    q: "Do you work with record labels?",
    a: "Yes. We run single-release campaigns and ongoing release calendars for labels, including high-volume playlist pushes and bulk Reels distribution across multiple artists.",
  },
  {
    q: "Which music genres do you promote?",
    a: "Our strongest networks cover Punjabi, Haryanvi, Rajasthani, Hindi and Bollywood-style music, plus indie and hip-hop releases. Playlist and creator matching is always done by genre, language and audience.",
  },
  {
    q: "How does Instagram Reels promotion work?",
    a: "We brief creators in our regional networks on your track, they publish Reels using your audio, and the campaign scales from hundreds to thousands of Reels depending on the package — with 7K\u201310K reels/day capability at full volume.",
  },
  {
    q: "Do you provide campaign reports?",
    a: "Yes. Every campaign includes clear updates and reporting — what was deployed, where it ran and what it delivered — so you always know what your budget achieved.",
  },
  {
    q: "What information is required to start a campaign?",
    a: "Just your track (link or file), release date, target audience or regions, and your budget range. Send these on WhatsApp and we will recommend the right campaign structure.",
  },
  {
    q: "Can I get a custom promotion package?",
    a: "Yes. Many clients combine Spotify playlist promotion with Instagram Reels and YouTube campaigns in one coordinated push. Message us on WhatsApp with your goals and we will build a custom quote.",
  },
];
